var $ac5ff71962864a84$exports = {};
$ac5ff71962864a84$exports = {
  "decrease": function decrease(args) {
    return "\u039C\u03B5\u03AF\u03C9\u03C3\u03B7 ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "\u0391\u03CD\u03BE\u03B7\u03C3\u03B7 ".concat(args.fieldLabel);
  },
  "numberField": "\u03A0\u03B5\u03B4\u03AF\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD"
};
export { $ac5ff71962864a84$exports as default };